"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultConfig = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _events = require("events");
var _lodash = _interopRequireDefault(require("lodash"));
var _qs = _interopRequireDefault(require("qs"));
var _auth0Js = _interopRequireDefault(require("auth0-js"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var events = _interopRequireWildcard(require("../../constants/events"));
var _routing = _interopRequireDefault(require("../../routing"));
var _api = require("../../lib/api");
var _regex = require("../../constants/regex");
var _clientStorage = require("../../utils/clientStorage");
var _authState = require("../../utils/authState");
var _tokens = require("../../utils/tokens");
var _errors = require("../../errors");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var BASE_URL = "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(window.location.port ? ":".concat(window.location.port) : '');
var defaultConfig = {
  clientId: 'PcggvMMnn7EzE9POSiz9CN4XtibvBfD2',
  allowedAuthorizedParties: [
  // client id for kubra.auth0.com
  'PcggvMMnn7EzE9POSiz9CN4XtibvBfD2',
  // client id for signin.kubra.com
  '6ZM3PyUURQhCoPchItcHZELoK8mkdvHn'],
  allowedIssuers: ['https://auth0.kubra.io/', 'https://kubra.auth0.com/', 'https://kubra-titanium.auth0.com/', 'https://signin.kubra.com/'],
  origin: 'kubra.auth0.com',
  audience: 'https://kubra.io/api',
  silentCallbackPath: "".concat(BASE_URL, "/login/silent-callback"),
  callbackPath: "".concat(BASE_URL, "/login/callback"),
  logoutPath: "".concat(BASE_URL, "/login/logout"),
  responseType: 'token id_token',
  scope: 'openid profile name email',
  rememberLastLogin: false,
  clientStorageType: _clientStorage.CLIENT_STORAGE_ALL,
  allowUrlConfig: false,
  iamApiHost: 'https://iam.kubra.io/api/v1',
  params: {
    prompt: 'select_account'
  }
};
exports.defaultConfig = defaultConfig;
var Auth0Wrapper = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2.default)(Auth0Wrapper, _EventEmitter);
  var _super = _createSuper(Auth0Wrapper);
  function Auth0Wrapper(config) {
    var _this;
    (0, _classCallCheck2.default)(this, Auth0Wrapper);
    _this = _super.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "queue", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isLock", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "config", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clientStorageType", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "auth0", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "createWebAuthForToken", function (accessToken) {
      var useAuthConfig = _this.config; // decode the token

      var decodedToken = (0, _jwtDecode.default)(accessToken); // get config data

      var allowedIssuers = _lodash.default.get(_this.config, ['allowedIssuers'], []);
      var allowedAuthorizedParties = _lodash.default.get(_this.config, ['allowedAuthorizedParties'], []); // if config has allowed issuers...

      if (!!allowedIssuers.length) {
        // get the issuer from the token
        var tokenIssuer = _lodash.default.get(decodedToken, 'iss'); //  if the issuer is allowed

        if (allowedIssuers.includes(tokenIssuer)) {
          // convert the issuer into a domain we can pass to Auth0 config
          var MATCH_DOMAIN = /^(?:.*:\/\/)([a-zA-Z0-9.-]*)(?:.*)/;
          var matchResults = tokenIssuer.match(MATCH_DOMAIN);
          var useOrigin = _lodash.default.get(matchResults, 1); // overwrite the origin in auth config to match the token issuer

          useAuthConfig = _objectSpread(_objectSpread({}, useAuthConfig), {}, {
            origin: useOrigin
          });
        }
      } // if config has allowed authorized parties...

      if (!!allowedAuthorizedParties.length) {
        var tokenAuthorizedParty = _lodash.default.get(decodedToken, 'azp'); // if the authorized party is allowed

        if (allowedAuthorizedParties.includes(tokenAuthorizedParty)) {
          // overwrite client id in config
          useAuthConfig = _objectSpread(_objectSpread({}, useAuthConfig), {}, {
            clientId: tokenAuthorizedParty
          });
        }
      } // create an auth0 instance used to get the userInfo

      return Auth0Wrapper.createWebAuth(useAuthConfig);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTokens", function () {
      return (0, _tokens.getTokens)(_this.clientStorageType);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTokens", function (tokens) {
      return (0, _tokens.setTokens)(tokens, _this.clientStorageType);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renewAuth", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var authResult;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.checkSession();
            case 3:
              authResult = _context.sent;

              // set the new tokens
              _this.setTokens(authResult); // use the new tokens to load the user information

              return _context.abrupt("return", _this.getUser(authResult));
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              throw _context.t0;
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renewalTransaction", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(requestPromiseFunc, fulfillmentCallback, rejectionCallback) {
        var createRetryRequest, queuedRequests;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this.isLock) {
                  _context3.next = 3;
                  break;
                }
                _this.queue.push({
                  requestPromiseFunc: requestPromiseFunc,
                  fulfillmentCallback: fulfillmentCallback,
                  rejectionCallback: rejectionCallback
                });
                return _context3.abrupt("return");
              case 3:
                // if this is the first promise func then engage the lock
                _this.isLock = true; // and add the first promise func to queue

                _this.queue.push({
                  requestPromiseFunc: requestPromiseFunc,
                  fulfillmentCallback: fulfillmentCallback,
                  rejectionCallback: rejectionCallback
                }); // then we try to renew our tokens

                _context3.prev = 5;
                _context3.next = 8;
                return _this.renewAuth();
              case 8:
                _context3.next = 14;
                break;
              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](5);

                // if renewal fails, sign the user out
                _this.signOut();
                return _context3.abrupt("return");
              case 14:
                // given a queued transaction, returns a promise that will retry the request and then call the
                // appropriate callback
                createRetryRequest = /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(transaction) {
                    var retryResponse;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return transaction.requestPromiseFunc();
                          case 3:
                            retryResponse = _context2.sent;
                            transaction.fulfillmentCallback(retryResponse);
                            _context2.next = 14;
                            break;
                          case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2["catch"](0);
                            // if the error was not a 401, call the rejection callback
                            transaction.rejectionCallback(_context2.t0); // if we get another 401 on the retry

                            if (!(_lodash.default.get(_context2.t0, ['response', 'status'], 0) === 401)) {
                              _context2.next = 14;
                              break;
                            }
                            transaction.rejectionCallback(_context2.t0); // if we get 401 on the retry, sign the user out

                            _this.signOut();
                            return _context2.abrupt("return");
                          case 14:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[0, 7]]);
                  }));
                  return function createRetryRequest(_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }(); // if renewal succeeds, retry all of the requests

                queuedRequests = _this.queue.map(function (transaction) {
                  return createRetryRequest(transaction);
                });
                _this.isLock = false;
                _this.queue = [];
                Promise.all(queuedRequests);
                return _context3.abrupt("return");
              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[5, 10]]);
      }));
      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "authGuard", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(requestPromiseFunc, fulfillmentCallback, rejectionCallback) {
        var tokens, invalidTokensError, response;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                tokens = _this.getTokens(); // if the tokens are invalid...

                if ((0, _tokens.isTokensValid)(tokens)) {
                  _context4.next = 6;
                  break;
                }
                invalidTokensError = new Error('Invalid Tokens'); // call the rejection callback

                rejectionCallback(invalidTokensError); // then sign the user out

                _this.signOut();
                return _context4.abrupt("return");
              case 6:
                _context4.prev = 6;
                _context4.next = 9;
                return requestPromiseFunc();
              case 9:
                response = _context4.sent;
                // if the request succeeded, return the output of the fulfillment callback
                fulfillmentCallback(response);
                _context4.next = 19;
                break;
              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](6);
                if (!(_lodash.default.get(_context4.t0, ['response', 'status'], 0) === 401)) {
                  _context4.next = 18;
                  break;
                }
                _this.renewalTransaction(requestPromiseFunc, fulfillmentCallback, rejectionCallback);
                return _context4.abrupt("return");
              case 18:
                // if the error was not a 401, return the output of the rejection callback
                rejectionCallback(_context4.t0);
              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[6, 13]]);
      }));
      return function (_x5, _x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "terminateSession", function (error) {
      _this.setTokens({
        accessToken: null,
        idToken: null
      });
      _this.emit(events.SESSION_TERMINATED, error);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "signOut", function (redirectTo) {
      _this.setTokens({
        accessToken: null,
        idToken: null
      });
      _this.emit(events.USER_SIGNED_OUT);
      var useRoute = _lodash.default.isUndefined(redirectTo) ? _routing.default.logout() : redirectTo;
      _this.auth0.logout({
        returnTo: encodeURI(useRoute)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "authenticate", function () {
      // get token data from client storage
      var tokenData = _this.getTokens(); // if we have valid tokens, that are not expired, use them to return the user data

      if ((0, _tokens.isTokensValid)(tokenData) && !(0, _tokens.isTokensExpired)(tokenData)) {
        return _this.getUser(tokenData);
      } // else redirect to login

      _this.auth0.authorize(_objectSpread({}, _this.shouldSetAuthState() && {
        state: (0, _authState.initializeAuthState)(_this.clientStorageType)
      }));
      return Promise.reject(new Error('Authentication Failed: No Valid Tokens'));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleAuthentication", function () {
      // get url params
      var hashString = window.location.hash.slice(1);
      var queryParams = _qs.default.parse(hashString);
      var accessToken = _lodash.default.get(queryParams, 'access_token'); // get an auth0 instance (create from token if available)

      var auth0Instance = _lodash.default.isUndefined(accessToken) ? _this.auth0 : _this.createWebAuthForToken(accessToken);
      return _this.parseHash(auth0Instance).then(function (authResult) {
        // if parse hash resolved null, reject promise...
        if (authResult === null) {
          return Promise.reject(new Error('Unable to process auth result.'));
        } // else parse for token data

        var tokenData = {
          accessToken: authResult.accessToken,
          idToken: authResult.idToken
        }; // ...persist them to client storage

        _this.setTokens(tokenData); // handle auth state...

        return _this.processAuthState(authResult).then(function () {
          _this.emit('authenticated', authResult); // ...use the tokens to get the current user

          return _this.getUser(tokenData);
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "shouldSetAuthState", function () {
      // initialize shouldRedirect to config value
      var shouldRedirectToCaller = _lodash.default.get(_this.config, ['redirectToCaller'], false); // check if config in url params is allowed

      var allowUrlConfig = _lodash.default.get(_this.config, ['allowUrlConfig'], false); // if allow Url config...

      if (allowUrlConfig === true) {
        // get query params
        var queryParams = _qs.default.parse(window.location.search, {
          ignoreQueryPrefix: true
        });
        var redirectToCallerParam = queryParams.redirectToCaller; // check for redirect to caller param

        switch (redirectToCallerParam) {
          case 'true':
            shouldRedirectToCaller = true;
            break;
          case 'false':
            shouldRedirectToCaller = false;
            break;
          default: // ...ignore all other values (so that config value is used)
        }
      }
      return shouldRedirectToCaller;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "processAuthState", function (authResult) {
      return new Promise(function (resolve, reject) {
        if (_lodash.default.isUndefined(authResult.state) || !(0, _authState.isStringAuthStateKey)(authResult.state)) {
          // if its not a kubra auth state key, we can resolve and let Auth0 handle it
          resolve();
          return;
        } // if it is a kubra auth state key...

        var accessToken = authResult.accessToken,
          state = authResult.state; // get the state data from client storage

        var stateData = (0, _clientStorage.getItem)(state, _this.clientStorageType); // if we could not find the state value in local storage, reject

        if (stateData === null) {
          reject(new Error('Auth State not found.'));
          return;
        } // we have the state value in memory, so remove the authState key(s) from client storage

        (0, _authState.removeAuthStateKeys)(_this.clientStorageType); // if state data was found in client storage...

        if (stateData !== null) {
          var _ref5 = stateData,
            redirectUrl = _ref5.redirectUrl,
            tenantId = _ref5.tenantId; // if a tenantId was found in auth state data...

          if (!_lodash.default.isUndefined(tenantId) && !_lodash.default.isUndefined(accessToken)) {
            // decode the access token
            var decodedAccessToken = (0, _jwtDecode.default)(accessToken); // get an array of the available tenantIds

            var tenantIds = _lodash.default.get(decodedAccessToken, 'https://kubra.com/tenantIds', []);
            if (tenantId && (
            // if the user is granted explicit tenant access
            tenantIds.includes(tenantId) // of if the user is granted all tenant access
            || tenantIds.includes('*'))) {
              // then set it in local storage
              (0, _clientStorage.setItem)('tenantId', tenantId, _this.clientStorageType);
            }
          } // if a redirectUrl was found in auth state data...

          if (!_lodash.default.isUndefined(redirectUrl)) {
            try {
              // try to decode it
              var decodedUrl = decodeURIComponent(redirectUrl); // confirm the url is valid

              if (_regex.MATCH_URL.test(decodedUrl)) {
                window.location.assign(decodedUrl);
              }
            } catch (err) {
              // if the URL is not valid, we can just resolve without redirecting
              resolve();
              return;
            }
          }
        } // if no state data was found, but we verified the key was present, we can resolve

        resolve();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getUser", function (tokenData) {
      // emit event to signal that we are loading the user
      _this.emit(events.LOADING_USER); // confirm that we have valid token data

      if (!(0, _tokens.isTokensValid)(tokenData)) {
        var invalidTokensError = new Error('TokenData is invalid.');
        return Promise.reject(invalidTokensError);
      }
      var _ref6 = tokenData,
        accessToken = _ref6.accessToken,
        idToken = _ref6.idToken;
      var decodedAccessToken = (0, _jwtDecode.default)(accessToken);
      var decodedIdToken = (0, _jwtDecode.default)(idToken); // use the decoded id token to construct the user profile

      var userInfo = _lodash.default.pick(decodedIdToken, ["sub", "name", "given_name", "family_name", "nickname", "picture", "email", "email_verified", "locale", "updated_at"]); // call to get users permissions

      return (0, _api.getUserPermissions)(_this.config.iamApiHost, accessToken).then(function (scopePermissions) {
        // get an array of the available tenantIds
        var tenantIds = _lodash.default.get(decodedAccessToken, 'https://kubra.com/tenantIds', []); // create user object

        var user = {
          scopePermissions: scopePermissions,
          credentials: {
            idToken: idToken,
            accessToken: accessToken
          },
          profile: userInfo,
          tenantIds: tenantIds
        };
        _this.emit(events.USER_FOUND, user);
        return user;
      }).catch(function (err) {
        return Promise.reject(new Error("Failed to load user permissions."));
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "parseHash", function () {
      var auth0Instance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // if an auth0 instance was provided, use it, else use instance we created on instantiation
      var auth0 = auth0Instance || _this.auth0;
      return new Promise(function (resolve, reject) {
        auth0.parseHash(function (auth0Error, authResult) {
          // if an error was returned, reject
          if (auth0Error) {
            switch (auth0Error.error) {
              case "invalid_token":
                reject(new _errors.StateMatchError(auth0Error.errorDescription));
                break;
              default:
                reject(new _errors.AuthError(_lodash.default.get(auth0Error, ['errorDescription'])));
            }
            return;
          }
          resolve(authResult);
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "userInfo", function (accessToken) {
      return new Promise(function (resolve, reject) {
        var auth0Instance = _this.createWebAuthForToken(accessToken);
        auth0Instance.client.userInfo(accessToken, function (auth0Error, userInfo) {
          if (auth0Error) {
            var _error = new Error('Failed to get Auth0 User Info');
            reject(Object.assign(_error, auth0Error));
          }
          resolve(userInfo);
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkSession", function () {
      return new Promise(function (resolve, reject) {
        _this.auth0.checkSession({
          /**
           * If redirectUri is not defined, it will default to the one provided to the Auth0.js
           * config, which is the callback page. Furthermore the redirectUri origin must match the
           * origin, which is a problem in local develop (where the callback is localhost:3001, but
           * the app window is at localhost:3000).
           *
           * To get around this we pass the silentCallbackPath as the redirectUrl, which should be a
           * URL on the same origin as the application (e.g. localhost:3000/login/silent-callback for
           * local development).
           *
           * This is not an issue in dev/qa/test/prod as they are all using the same origin for both
           * the callback and application pages.
           */
          redirectUri: _this.config.silentCallbackPath
        },
        // callback for auth0.checkSession
        function (auth0Error, authResult) {
          if (auth0Error) {
            var _error2 = new Error('Failed to renew Auth0 session');
            reject(Object.assign(_error2, auth0Error));
          } // if no error, resolve promise

          resolve(authResult);
        });
      });
    });
    _this.queue = [];
    _this.isLock = false; // merge received config options with default config

    _this.config = _objectSpread(_objectSpread({}, defaultConfig), config);
    _this.clientStorageType = _lodash.default.get(_this.config, ['clientStorageType'], _clientStorage.CLIENT_STORAGE_ALL);
    _this.auth0 = Auth0Wrapper.createWebAuth(_this.config);
    return _this;
  }
  (0, _createClass2.default)(Auth0Wrapper, null, [{
    key: "createWebAuth",
    value: function createWebAuth(config) {
      return new _auth0Js.default.WebAuth({
        clientID: config.clientId,
        domain: config.origin,
        redirectUri: config.callbackPath,
        responseType: config.responseType,
        audience: config.audience,
        scope: config.scope
      });
    }
    /**
     * Given an access token, return an Auth0 instance setup with config params that will work with
     * that token (eg origin/issuer, authorized party)
     */
  }]);
  return Auth0Wrapper;
}(_events.EventEmitter);
exports.default = Auth0Wrapper;